export const handleApiError = (error) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        switch (error.response.status) {
            case 401:
                return {
                    type: 'AUTH_ERROR',
                    message: 'Authentication failed. Please login again.'
                };
            case 403:
                return {
                    type: 'FORBIDDEN',
                    message: 'You do not have permission to perform this action.'
                };
            case 404:
                return {
                    type: 'NOT_FOUND',
                    message: 'The requested resource was not found.'
                };
            default:
                return {
                    type: 'API_ERROR',
                    message: error.response.data.message || 'An error occurred while processing your request.'
                };
        }
    } else if (error.request) {
        // The request was made but no response was received
        return {
            type: 'NETWORK_ERROR',
            message: 'Unable to connect to the server. Please check your internet connection.'
        };
    } else {
        // Something happened in setting up the request that triggered an Error
        return {
            type: 'REQUEST_ERROR',
            message: 'An error occurred while preparing your request.'
        };
    }
};